<template>
  <DynamicFeaturesPage feature="dna-budgets-prototype">
    <template #enabled>
      <DNABudgets></DNABudgets>
    </template>
    <template #disabled>
      <Budgets></Budgets>
    </template>
  </DynamicFeaturesPage>
</template>

<script>
import DynamicFeaturesPage from "../components/featureFlags/DynamicFeaturesPage.vue";
import Budgets from "./Budgets.vue";
import DNABudgets from "./DNABudgets.vue";

export default {
  mixins: [],

  components: {
    Budgets,
    DynamicFeaturesPage,
    DNABudgets,
  },

  props: {},

  data() {
    return {};
  },

  methods: {},

  computed: {},
};
</script>
